import { NoticeVariant } from './types';

interface NoticeCopy {
  title: string;
  body: string;
  showContact: boolean;
}

export const NOTICE_COPY: Record<NoticeVariant, NoticeCopy> = {
  updated: {
    title: 'This quote has been updated',
    body: "The version you're viewing is no longer current. Please contact your sales rep for the latest version.",
    showContact: true
  },
  unavailable: {
    title: 'This quote is no longer available',
    body: 'Please contact your sales rep.',
    showContact: true
  },
  notFound: {
    title: 'Quote not found',
    body: 'Please double-check the link or contact your sales rep.',
    showContact: false
  }
};
